module.exports = function getResource(label, vars = []) {
    const resources = {
        orderDetails: 'Détails de la commande',
        orderHistory: 'Afficher l’historique complet des commandes',
        yourOrderNumber: 'Votre numéro de commande est',
        confirmationEmail: 'You’ll receive a confirmation email at',
        viewOrderDetails: 'Afficher les détails de la commande',
        continueShopping: 'Continuer à magasiner',
        successMessage: 'Une commande de remplacement a été passée.',
        failureMessage: 'Désolé, cette demande a été refusée.',
        failureMessageParagraph1: 'Nous avons examiné votre demande, et votre commande n’est pas admissible pour un remplacement. Pour toute question ou aide supplémentaire, veuillez communiquer avec le service à la clientèle.',
        somethingWrong: 'Oups... Un problème est survenu.',
        somethingWrongMessage: 'Un problème est survenu lors du traitement de votre soumission.',
        tryAgain: 'Réessayer'
    };

    return resources[label];
};
